<template>
  <section class="section_bg section custom_page_v2" >
    <loading-block v-if="isload==false" :loading="!isload"/>
    <card class="loading_div section_black" v-if="isload==false">
      <h2>{{ load_message }}</h2>
    </card>

    <div class="" v-if="isload==true">
      <div class="">

        <div class="section_header mobile_div back_div_element"   >
          <router-link tag="a" class="btn" :to="{name: 'setup_link'}"  ><i class="fa fa-backward"></i> Назад</router-link>

        </div>

        <div class="section_header mobile_div nocenter">





          <tabs @tabchange="onTabChange" :activeTab="activeTab" :value="activeTab" fill class="flex-column flex-md-row tabs_style">
            <card shadow>
              <tab-pane title="avatar">
            <span slot="title" class="tab_style">
                Фотография
            </span>
                <div class="row  notify_tab mb-5 description">
                  <div class="col-md-6 col-12 mt-2">
                    <div   v-if="isload_avatar">
                      <img :src="image_url+avatar+'?'+Math.random()" class="col-md-4 center-block img img-thumbnail-avatar">
                    </div>
                  </div>
                  <div class="col-md-6 col-12 mt-2">
                    <vue-dropzone @vdropzone-success="vdropzone_complete($event)" ref="myVueDropzone" id="dropzone"
                                  :options="dropzoneOptions"></vue-dropzone>
                  </div>
                </div>
              </tab-pane>

              <tab-pane title="security" v-if="user.user_login && user.user_password">
            <span slot="title" class="tab_style">
                Безопасность
            </span>
                <div class="row notify_tab mb-5 description">
                  <div class="col-12">
                  <div class="form-group">
                    <label for="exampleInputPassword1">Старый Пароль</label>
                    <input type="password" v-model="change_password.old_password" class="form-control" id="exampleInputPassword1" placeholder="Введите пароль">
                  </div>
                  </div>
                  <div class="col-12">
                  <div class="form-group">
                    <label for="exampleInputPassword1">Новый пароль</label>
                    <input type="password" v-model="change_password.new_password" class="form-control" id="exampleInputPassword1" placeholder="Введите пароль">
                  </div>
                  </div>
                  <div class="col-12">
                  <div class="form-group">
                    <label for="exampleInputPassword1">Повтор пароля</label>
                    <input type="password" v-model="change_password.new_password_2" class="form-control" id="exampleInputPassword1" placeholder="Введите пароль">
                  </div>
                  </div>
                  <div class="alert alert-warning" v-if="is_form_change_password_error" v-html="form_change_password_error_message">

                  </div>
                  <div class="alert alert-success" v-if="is_form_change_password_success" v-html="form_change_password_success_message">

                  </div>
                  <div class="col-12">
                  <p><button @click="changePassword()" class="btn btn-second">Сменить<br>пароль</button></p>
                  </div>
                </div>
              </tab-pane>

              <tab-pane title="notifys">
            <span slot="title">

                Уведомления
            </span>
                <div class="row  notify_tab mb-5 description">

                    <div class="col-md-6 col-12">
                      <label for="exampleInputEmail1">Уведомления на сайте </label>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.blogpost_answer_on_comment"/> На ваш комментарий к записи ответили</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.blogpost_new_comment"/> К вашей записи написали комментарий</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.developer_send_offer"/> Исполнитель отправил свою цену за проект</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.new_comment_in_offer_on_project" /> Новый комментарий в проекте на стадии поиска исполнителя</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.you_assign_is_developer" /> Сообщение когда вас выбрали исполнителем проекта</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox"  v-model="notifys.site.new_comment"/> Новые комментарии в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.new_comment_on_your_comment" /> Новые ответы к вашим комментариям в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.developer_create_invoice" /> Исполнитель создал счет</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.create_new_task" /> В проекте создали новую задачу.</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.site.project_update" /> Обновлена информация о проекте</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.client_accept_condition_on_invoice" /> Условия по счету подтверждены</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.change_status" /> Установлен новый статус в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox"  v-model="notifys.site.invoice_set_complete" /> Условия по счету выполнены</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.client_pay_to_invoice" /> Клиент оплатил счет</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.invoice_close" /> Счет закрыт</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.site.invite_to_task" /> Приглашение в проект или задачу</p>
                      </div>
                    </div>
                    <div class="col-md-6 col-12" v-if="user.telegram_id && user.telegram_id>0">
                      <label for="exampleInputEmail1">Уведомления  в Telegram </label>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.telegram.blogpost_answer_on_comment"/> На ваш комментарий к записи ответили</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.blogpost_new_comment"/> К вашей записи написали комментарий</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.developer_send_offer"/> Исполнитель отправил свою цену за проект</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.new_comment_in_offer_on_project" /> Новый комментарий в проекте на стадии поиска исполнителя</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.you_assign_is_developer" /> Сообщение когда вас выбрали исполнителем проекта</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox"  v-model="notifys.telegram.new_comment"/> Новые комментарии в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.new_comment_on_your_comment" /> Новые ответы к вашим комментариям в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.developer_create_invoice" /> Исполнитель создал счет</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.create_new_task" /> В проекте создали новую задачу.</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.project_update" /> Обновлена информация о проекте</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.client_accept_condition_on_invoice" /> Условия по счету подтверждены</p>
                      </div>
                      <div class="row p-1">
                        <p> <input type="checkbox" v-model="notifys.telegram.change_status" /> Установлен новый статус в проекте или задаче</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox"  v-model="notifys.telegram.invoice_set_complete" /> Условия по счету выполнены</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.client_pay_to_invoice" /> Клиент оплатил счет</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.invoice_close" /> Счет закрыт</p>
                      </div>
                      <div class="row p-1">
                        <p><input type="checkbox" v-model="notifys.telegram.invite_to_task" /> Приглашение в проект или задачу</p>
                      </div>
                    </div>

                </div>
              </tab-pane>

              <tab-pane title="Account">
             <span slot="title">

                Реквизиты и Описание
              </span>
                <div class="description">
                  <div class="row  notify_tab mb-5">
                    <div class="col-12 col-md-4">
                      <p>Имя</p>
                    </div>
                    <div class="col-12 col-md-8">

                    <input type="text" class="form-control" v-model="user.name" placeholder="Введите имя"/>





                    </div>
                  </div>
                  <div class="row notify_tab mb-5" v-if="is_load_wallet==true && is_can_use_ton_wallet==true">
                    <div class="col-12 col-md-4">
                      <p>Кошелек TON</p>
                    </div>
                    <div class="col-12 col-md-8">
                      <div class="alert alert-danger" v-if="user.wallet_ton==null">
                        <p >Вы не привязали кошелек</p>

                      </div>
                      <p class="text-center" v-if="user.wallet_ton!=null">текущий кошелек:</p>
                      <p class="text-center" v-if="user.wallet_ton!=null">{{ user.wallet_ton }}</p>
                      <p class="text-center" v-if="is_show_btn_connect_ton_wallet"><button class="btn btn-sm"  @click="connectWallet" id="TON_PAYMENT_BTN">Подключить<br/>кошелек</button></p>
                      <p class="text-center" v-if="is_show_unsave_wallet_ton" ><button class="btn btn-sm" @click="walletDisconnect" >Отключить</button></p>

                      <p class="text-center" v-if="is_show_unsave_wallet_ton"> {{ unsave_wallet_ton}}</p>
                      <p  class="text-center" v-if="is_show_unsave_wallet_ton"><button @click="saveWalletTon" class="btn btn-sm" >сохранить <br>кошелек</button></p>


                    </div>
                  </div>
                <div class="row  notify_tab mb-5">
                  <div class="col-12 col-md-4">
                    <p>Реквизиты</p>
                  </div>
                  <div class="col-12 col-md-8">

                    <textarea class="form-control text_rekv" required id="exampleInputEmail1" v-model="account"
                              placeholder="Введите реквизиты"></textarea>




                  </div>
                </div>
                  <div class="row  notify_tab mb-5">
                    <div class="col-12 col-md-4">
                      <p>Описание</p>
                    </div>
                    <div class="col-12 col-md-8">

                    <textarea class="form-control text_rekv" maxlength="499" required id="exampleInputEmail1" v-model="description"
                              placeholder="Введите описание"></textarea>




                    </div>
                  </div>
                </div>
              </tab-pane>
            </card>
          </tabs>

          <div class="row ml-5 mb-5">

            <div class="col-12">
              <div class="alert alert-danger" v-if="iserror==true">
                <p>{{ error_message }}</p>
              </div>






            </div>


          </div>
          <div class="row">
            <div class="col-6">
            </div>
            <div class="col-6">
              <button type="submit" @click="onSubmit($event)" class="mt-3 btn btn">Сохранить
              </button>
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>

</template>
<script>

import {eventBus} from "@/main";
import axios from 'axios';
import Vue from "vue";
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import Api from "@/models/Api";
import LoadingBlock from "@/components/Custom/LoadingBlock";
import Tabs from "@/components/Tabs/Tabs";
import Tab from "@/components/Tabs/Tab";
import TabPane from "@/components/Tabs/TabPane";
import UserModel from "../../models/UserModel";
import base64url from "base64url";


export default {
  name: "home",

  data() {
    var app = this;


    return {
      "notify_counts": {
        "projects": 0,
        "freelance": 0,
        "comments": 0,
        "invoices": 0,
      },
      notify_count: 0,
      notify_count_invoices:0,
      notify_count_tasks:0,
      "iserror": false,
      "error_message": null,
      "description":null,
      'account': '',
      'avatar': "",
      "change_password":{
        "old_password":"",
        "new_password":"",
        "new_password_2":"",
      },
      'is_form_change_password_error':false,
      'form_change_password_error_message':'',
      'is_form_change_password_success':false,
      'form_change_password_success_message':'',
      "services":[],
      "load_message":"Идет загрузка..",
      "isload_avatar": false,
      "user": null,
      'image_url': null,
      'isload': false,
      'verifications':[],
      'notifys':{},
      'is_can_use_ton_wallet':false,
      'loaded_blog_category':false,
      'categorys_blog':[],
      'return_back':'',
      'activeTab':"avatar",
      'is_load_wallet':false,
      'is_show_btn_connect_ton_wallet':false,
      'is_show_btn_save_wallet':false,
      'unsave_wallet_ton':null,
      'is_show_unsave_wallet_ton':false,


      dropzoneOptions: {
        url: Vue.config.API_URL + 'uploadavatar',
        thumbnailWidth: 150,
        maxFilesize: 10.0,
        dictDefaultMessage: "<i class='fa fa-cloud-upload'></i>Загрузить фото",
        headers: {"Authorization": "Bearer " + app.$store.getters.TOKEN},


      }
    }
  },
  async mounted() {




    var app = this;
    // try{
    //   await app.load_script('https://unpkg.com/@tonconnect/ui@latest/dist/tonconnect-ui.min.js');
    //
    //   await app.load_script('https://unpkg.com/tonweb@0.0.41/dist/tonweb.js');
    // }catch (e){
    //
    // }


    app.isload = false;
    app.account = '';
    app.description="";
    // Код, который будет запущен только после
    // отображения всех представлений



    if (app.$store.getters.USER) {


      var tmp_user = app.$store.getters.USER;

      app.user = tmp_user;

      app.image_url = Vue.config.IMAGE_URL;



      Api.loadAccount(async function(data){

        app.is_can_use_ton_wallet=data.is_can_use_ton_wallet;
        app.return_back=data.return_back;
        app.account = data.account;
        app.notifys=data.notifys;
        //app.verifications=data.verifications;
        app.services=data.services;
        app.user=data.user;


        app.description=data.user.description;
        app.isload = true;
        if (app.user.avatar) {
          app.avatar = app.user.avatar;

          app.isload_avatar = true;
        }
        if(app.is_can_use_ton_wallet==true){
          try{
            await app.initTonConnect();
          }catch (e){

          }


        }
      })

      app.isload = true;
    }else {
      eventBus.$on('user_is_login', user => {
        this.islogin = false;

        if (typeof user === 'object') {


          if("api_token" in user){

            if (user.api_token) {

              var tmp_user=user;


              app.user = tmp_user;
              app.image_url = Vue.config.IMAGE_URL;


              Api.loadAccount(function(data){

                app.return_back=data.return_back;
                app.is_can_use_ton_wallet=data.is_can_use_ton_wallet;
                app.account = data.account;
                //app.verifications=data.verifications;
                app.notifys=data.notifys;
                app.isload = true;
              })

              if (app.user.avatar) {
                app.avatar = app.user.avatar;
                app.isload_avatar = true;
              }




            }
          }
        }


      });
    }








  },

  methods: {
    changePassword(){
        var app=this;
        app.is_form_change_password_error=false;
      app.is_form_change_password_success=false;
        Api.startUserChangePassword(app.change_password,function(data){
          app.form_change_password_success_message="Пароль успешно изменен!";
          app.is_form_change_password_success=true;

        },function(err){


          if(err.response.data.errors && Object.entries(err.response.data.errors).length>0){
            var final_err_message='';
            for (const [key, value] of Object.entries(err.response.data.errors)) {
              for (const [key_obj, value_obj] of Object.entries(value)) {

                final_err_message=final_err_message+'<p>'+value_obj+'</p>';
              }

            }
            app.form_change_password_error_message=final_err_message;
            app.is_form_change_password_error=true;
          }else {
            app.form_change_password_error_message=err.response.data.message;
            app.is_form_change_password_error=true;
          }



        });

    },
    saveWalletTon(){
      var app=this;
      var current_wallet=app.unsave_wallet_ton;

      var form={};
      form["wallet_ton"]=current_wallet;

      Api.setAccountWalletTon(form, function () {
        document.location.reload();

      }, function (message) {
        app.iserror = true;
        app.error_message = message;
        app.disableLoad();

      })
    },
    async walletDisconnect(){
      var app=this;

      try{
        app.is_show_btn_connect_ton_wallet=true;
        app.is_show_btn_save_wallet=false;
        app.is_show_unsave_wallet_ton=false;
        await app.tonConnectUI.disconnect();

      }catch (err){

      }

    },
    async connectWallet(){
      var app=this;
      try{
        const connectedWallet = await app.tonConnectUI.connectWallet();

        app.is_show_btn_connect_ton_wallet=false;
        app.is_show_btn_save_wallet=true;

      }catch (err){

      }

    },
    load_script (url) {
      let self = this
      return new Promise((resolve, reject) => {

        // if script is already loading via another component
        if ( self.is_script_loading ){
          // Resolve when the other component has loaded the script
          this.$root.$on('script_loaded', resolve)
          return
        }

        let script = document.createElement('script')
        script.setAttribute('src', url)
        script.async = true

        this.$root.$emit('loading_script')

        script.onload = () => {
          /* emit to global event bus to inform other components
           * we are already loading the script */
          this.$root.$emit('script_loaded')
          resolve()
        }

        document.head.appendChild(script)

      })

    },
    async initTonConnect(){

      var app=this;
   //   var sum=app.invoice.sum;

      var url_manifest=Vue.config.BASE_URL_FRONT+'tonconnect-manifest.json';





      if(UserModel.isTWA()){

        var url_back=app.return_back;

        //url_back="https://t.me/durov";

        app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
          manifestUrl: url_manifest,
          twaReturnUrl: url_back,
          language: 'ru',
          actionsConfiguration:{
            'returnStrategy':url_back
          }
        });

        // app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
        //   manifestUrl: url_manifest,
        //   twaReturnUrl: url_back,
        //
        // });



        app.is_load_wallet = true;
      }else {
        app.tonConnectUI = new TON_CONNECT_UI.TonConnectUI({
          manifestUrl: url_manifest,
          language: 'ru'

        });
        app.is_load_wallet = true;
      }

      app.is_show_btn_connect_ton_wallet=true;
      const walletsList = await app.tonConnectUI.getWallets();

      const unsubscribe = app.tonConnectUI.onStatusChange(
          walletAndwalletInfo => {

            const currentAccount = app.tonConnectUI.account;
            if(currentAccount!=null){

              app.is_show_btn_connect_ton_wallet=false;
              app.is_show_btn_save_wallet=true;
              var rawAddress=walletAndwalletInfo.account.address;

              const Address = TonWeb.utils.Address;

              const address = new Address(rawAddress);
              var adress_friendly=address.toString({isUserFriendly:true});
              app.unsave_wallet_ton=adress_friendly;
              app.is_show_unsave_wallet_ton=true

            }


            // update state/reactive variables to show updates in the ui
          }
      );

    },
    updateNotifyCount() {

      var app = this;


      try{
        Api.loadNotifyCount(function (notifys) {


          app.notify_count = notifys.count;
          app.notify_count_invoices=notifys.count_invoices;
          app.notify_count_tasks=notifys.count_tasks;
          var total_count=app.notify_count+app.notify_count_invoices;
          app.total_count=total_count;

          var emit_params={};
          emit_params.notify_count=app.notify_count;
          emit_params.notify_count_invoices=app.notify_count_invoices;
          emit_params.notify_count_tasks=app.notify_count_tasks;
          eventBus.$emit("update_notify_count",emit_params)


        });
      } catch(e){

      }

      setTimeout(app.updateNotifyCount, 5000)


    },
    setLoad(message="Идет загрузка..."){
      var app=this;
      app.isload=false;
      app.load_message=message;

    },
    onTabChange(tab_active){
     this.activeTab=tab_active;
    },
    disableLoad(){
      var app=this;
      app.load_message="Идет загрузка";
      app.isload=true;
    },
    onSubmit(event) {

      event.preventDefault();
      var app = this;
      app.isload=false;
      app.setLoad("Идет сохранение...");
      var form={};
      var new_notifys={"site":{},'telegram':{}};

      if(app.notifys && app.notifys.site){
        Object.keys(app.notifys.site).map(function(objectKey, index) {

          new_notifys['site'][objectKey]=app.notifys.site[objectKey];

        });
      }
      if(app.notifys && app.notifys.telegram){
        Object.keys(app.notifys.telegram).map(function(objectKey, index) {

          new_notifys['telegram'][objectKey]=app.notifys.telegram[objectKey];

        });
      }
      form['account']=app.account;
      form['name']=app.user.name;
      form['notifys']=new_notifys;
      form['description']=app.description;




      Api.setAccount(form, function () {
        app.iserror = false;
        app.disableLoad();

      }, function (message) {
        app.iserror = true;
        app.error_message = message;
        app.disableLoad();

      })


    },
    vdropzone_complete(file) {
      var app=this;
      app.isload=false;

      var response = JSON.parse(file.xhr.response);

      Api.loadAccount(function(data){
        if (app.user.avatar) {
          app.avatar = app.user.avatar;

          app.isload_avatar = true;
        }
        app.isload = true;

      })
    }
  },
  components: {Tabs,Tab,TabPane,vueDropzone: vue2Dropzone,LoadingBlock}
};
</script>